/**
 * @license Exactag Varnish Script v0.8.9
 * | Copyright 2015 Otto (GmbH & Co KG), 22172 HAMBURG
 * | http://www.otto.com
 * | Date: 2015-02-19
 */

window.o_global = window.o_global || {};
window.lhotse = window.lhotse || {};

window.lhotse.exactag = window.lhotse.exactag || {};
window.lhotse.exactag.centralFinished = false;
window.lhotse.exactag.finished = false;
/**
 * since ios privacy transparency exactag must not be executed
 * Until apps send an ok
 */
window.lhotse.exactag.execute = false;

// Varnish-Objekt
window.lhotse.exactag.varnish = {
  version: "0.8.9",
  data: [],
};

// * * *
// Beispiel für die Ausgabe eines Includes:
// ```
// lhotse.exactag.varnish.data.push({"ag":"3","cs":"BK"});
// ```
// Hinweis:
// Es sollte in Hinsicht auf die Minimierung von Globalen das neue Objekt
// stets direkt in die push-Methode geschrieben werden
// * * *
// Mikro-Optimierung: window lokale Variable
(function (win) {
  const { host } = win.location;
  const env = `${win.location.protocol}//${host}`;
  const varnishURL =
    window.lhotse.exactag.varnishURL ||
    `${env}/shoppages-exactag/getPerformanceMarketingData.js`;
  const firstChar = varnishURL.substring(0, 1);
  const { hash } = win.location;
  let variationId = "";
  const EMERGENCY_PXC_TOGGLE = "EMR_PXC";
  // Regulärer Ausdruck zum Auffinden der 'variationId' in der URL
  const re = new RegExp(/variationId=([a-zA-Z0-9_\-]*)/);

  // Wenn eine ```variationId``` gefunden wurde,
  // dann erstellen wir daraus einen Parameter für den Ajax-Call
  if (re.test(hash)) {
    variationId = `?variationId=${hash.match(re)[1]}`;
  }

  // Ajax-Call mit Übergabe des ```variationId```-Parameters (falls vorhanden)
  window.lhotse.exactag.getVarnishData = function (url) {
    window.o_util.ajax.getScript(url).then(function (xhr) {
      // Method getScript contains no error-handling, so the
      // returning xhr object has to be checked manually for valid status code.
      if (xhr.status === 200 || xhr.status === 304) {
        //! Methode bei erfolgreichem Response
        // Festlegen, dass der Ajax-Call erfolgreich beendet wurde
        window.lhotse.exactag.finished = true;

        // Wenn in der 'exactag.central.js' die Vorprüfung auf 'varnish'-Daten abgeschlossen ist,
        // dann rufe die eigentlich Track-Methode zur weiteren Verarbeitung des Data-Objekts auf
        if (window.lhotse.exactag.centralFinished) {
          window.lhotse.exactag.continueTrack();
        }
      } else {
        //! Methode bei fehlerhaftem Ajax-Call
        const msg = `Triggered ajaxError handler in '${varnishURL}'! Status: ${xhr.status}`;

        // Ausgabe der Fehlermeldung
        if (win.console) {
          console.log(msg);
        }
      }
    });
  };

  const execute = () => {
    // (Sicherheits-)Check auf relativen Pfad beim Vorhandensein der 'lhotse.exactag.varnishURL'-Variable
    if (window.lhotse.exactag.varnishURL) {
      if (firstChar === "." || firstChar === "/") {
        window.lhotse.exactag.getVarnishData(varnishURL);
      }
    } else {
      window.lhotse.exactag.getVarnishData(varnishURL + variationId);
    }
  };

  const appsConsent = "ft-apps.tracking.userATTOptInStatusChanged";
  const ft4cbConsent = "ft4.cookie-banner.consentAccepted";
  window.lhotse.exactag.consents = {};
  window.lhotse.exactag.consents[ft4cbConsent] = {
    received: false,
    accept: false,
  };
  window.lhotse.exactag.consents[appsConsent] = {
    received: false,
    accept: false,
  };
  window.lhotse.exactag.consentResult = { received: false, accept: false };

  const processConsentAnswer = (consent, yes) => {
    window.lhotse.exactag.consents[consent].received = true;
    window.lhotse.exactag.consents[consent].accept = yes;

    /**
     * After this loop consent result will be only true if everything is true
     */
    const consentResult = { received: true, accept: true };
    window.lhotse.exactag.consentResult = consentResult;

    Object.keys(window.lhotse.exactag.consents).forEach((k) => {
      consentResult.received =
        consentResult.received && window.lhotse.exactag.consents[k].received;
      consentResult.accept =
        consentResult.accept && window.lhotse.exactag.consents[k].accept;
    });

    /** Only start exactag if all consents were given */
    if (consentResult.received && consentResult.accept) {
      window.lhotse.exactag.execute = true;
      execute();
    }
  };

  // Hier prüfen wir auf vorhanden sein von CB
  // Und initialisieren CB consent antwort , so als wäre es über event
  window.lhotse.exactag.onLoad = () => {
    // If main toggle is switched off, abort init
    if (
      !window.o_util.toggle.get(EMERGENCY_PXC_TOGGLE, true) ||
      window.o_util.misc.isPreview(win.location.href) ||
      // CB not accepted
      !window.o_util.cookie.get("cb") ||
      window.o_util.cookie.get("cb") === "0"
    ) {
      // Disable for CB
      processConsentAnswer(ft4cbConsent, false);
    } else {
      // Otherwise enable tracking for CB
      processConsentAnswer(ft4cbConsent, true);
    }

    // Exactag wurde nicht durch handler aufgerufen
    // Weil noch was fehlt
    // * Dann laden wir exactag script aber trotzdem
    if (!window.lhotse.exactag.consentResult.received) {
      // Lade exactag ohne es zu aktivieren
      execute();
    }
  };

  // ! Wir werden IMMER warten auf event von apps
  // ! bevor wir tracken
  window.o_global.eventQBus.on(appsConsent, (yes) => {
    processConsentAnswer(appsConsent, yes);
  });

  // Das ist der event wenn CB nachträglich akzeptiert wird
  window.o_global.eventQBus.on(ft4cbConsent, () => {
    window.lhotse.exactag.addPartnerConsents().then(() => {
      processConsentAnswer(ft4cbConsent, true);
    });
  });

  window.o_global.eventLoader.onLoad(21, function () {
    window.lhotse.exactag.onLoad();
  });
})(window);
